module.exports = __webpack_public_path__ + "img/img30.eda67946.svg";